import { render, staticRenderFns } from "./MedicalExam.vue?vue&type=template&id=7411f899&"
import script from "./MedicalExam.vue?vue&type=script&lang=js&"
export * from "./MedicalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports